import { useMemo } from 'react';

import ArrowDown from '@/assets/ic_arrow_down.svg';
import ArrowUp from '@/assets/ic_arrow_up.svg';
import { TopRankingTDA } from '@/types/tda';
import { cn, formatearNumero } from '@/utils/functions';

export const ItemRanking = ({
  data,
  isGeneral,
  isFirstMathDayRanking,
  rankingAvailable,
}: {
  data: TopRankingTDA;
  isGeneral: boolean;
  isFirstMathDayRanking: boolean;
  rankingAvailable?: boolean;
}) => {
  const isPositive = data?.diferenciaPosicion && data?.diferenciaPosicion > 0;

  const formatColor = useMemo(() => {
    if (data?.diferenciaPosicion && data?.diferenciaPosicion === 0)
      return 'text-gdt-gray-2';
    return isPositive ? 'text-gdt-status-green' : 'text-gdt-status-red';
  }, [data, isPositive]);

  return (
    <div className="flex justify-stretch bg-white border-b-gdt-gray-6 border-b-[1px] px-7 lg:py-6 text-xs font-semibold text-gdt-gray-3 py-4">
      <div className="w-12 lg:w-[68px]">
        <div
          className={cn(
            'rounded-full bg-gdt-blue text-white w-9 h-9 lg:w-10 lg:h-10 font-bold text-lg flex justify-center items-center',
            { 'text-gdt-blue bg-gdt-blue-light2': data.nroPos !== 1 }
          )}
        >
          <span>{data.nroPos}</span>
        </div>
      </div>
      {isGeneral && rankingAvailable && (
        <div className="text-left w-8 flex flex-column justify-baseline">
          <div className="text-center text-xs font-semibold mt-[2px]">
            {data?.diferenciaPosicion &&
            data?.diferenciaPosicion !== 0 &&
            !isFirstMathDayRanking ? (
              <>
                <img
                  alt="Icon arrow"
                  className="w-5 h-5 self-center inline-block align-middle"
                  src={isPositive ? ArrowUp : ArrowDown}
                />
                <p className={formatColor}>
                  {String(data.diferenciaPosicion)?.replaceAll('-', '')}
                </p>
              </>
            ) : (
              <span className="w-5 h-5 bg-gdt-gray-6 rounded-full flex justify-center items-center">
                -
              </span>
            )}
          </div>
        </div>
      )}
      <div className="flex-1 space-y-1">
        <p className="font-bold text-gdt-gray">{data.dt}</p>
        <p className="uppercase font-bold text-3xs text-gdt-gray-2">
          {data.equipo}
        </p>
        {!isGeneral && (
          <p className="font-bold text-3xs text-gdt-blue-header">
            {data.modificoEquipo ? 'Modificó equipo' : 'No modificó equipo'}
          </p>
        )}
      </div>
      <p className="w-[68px] text-center lg:w-[200px] lg:text-center">
        {data.vecesGanoFecha +
          `${data.vecesGanoFecha !== 1 ? ' veces' : ' vez'}`}
      </p>
      <p className="w-[62px] text-right lg:w-[113px] lg:text-center">
        {formatearNumero(data.puntos)}
      </p>
    </div>
  );
};
